import { useCallback, useEffect, useState } from "react";
import {
  Box,
  Grid,
  Typography,
  Paper,
  IconButton,

  Divider,
} from "@mui/material";
import SaveIcon from "@mui/icons-material/Save";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import { useForm } from "react-hook-form";

import WSTextField, { TextType, CurrencyType } from "../../../Components/TextBox/WSTextBox";
import WSSelectField from "../../../Components/Select/WSSelect";
import { useFieldArray } from "react-hook-form";
import { callAPI, formatCurrency, Method } from "../../../commonFunctions/CommonFunctions";
import { useSnackbar } from "../../../Components/Snackbar/SnackBarContext";
import { useNavigate, useParams } from "react-router-dom";


const Quotation = () => {
  const { showMessage } = useSnackbar();
  const { id } = useParams<{ id: string }>();
  const isEditMode = Boolean(id);

  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [items, setItems] = useState<any[]>([]);
  const [customers, setCustomers] = useState<any[]>([])
  const [calculatedValues, setCalculatedValues] = useState({
    subtotal: 0,
    totalDiscount: 0,
    totalTax: 0,
    total: 0,
  });

  const { control, handleSubmit, setValue, reset, watch, getValues, register } = useForm({
    mode: "onChange",
    defaultValues: {

      CustomerId: "",

      Remarks: "",

      items: [
        {
          ItemId: "",
          Quantity: 1,
          Price: "",
          Total: 0,
        },
      ],
    }
  });

  const { fields, append, remove } = useFieldArray({
    control,
    name: "items",
  });

  const watchedItems = watch("items");

  useEffect(() => {
    calculateInvoiceTotals();
  }, [watchedItems]);

  const calculateInvoiceTotals = useCallback(() => {
    const items = getValues("items") || [];
    console.log("Calculating totals for items:", items);

    let subtotal = 0;
    let totalDiscount = 0;
    let totalTax = 0;

    items.forEach((item: any, index: number) => {
      const quantity = Number(item.Quantity) || 1;
      const unitPrice = Number(item.Price) || 0;
      // const discount = Number(item.Discount) || 0;
      // const taxRate = Number(item.TaxRate) || 0;

      const itemSubtotal = quantity * unitPrice;
      // const itemDiscount = (itemSubtotal * discount) / 100;
      // const taxableValue = itemSubtotal - itemDiscount;
      // const itemTax = (taxableValue * taxRate) / 100;

      subtotal += itemSubtotal;
      // totalDiscount += itemDiscount;
      // totalTax += itemTax;

      // Update item total
      setValue(`items.${index}.Total` as any, itemSubtotal /* - itemDiscount + itemTax */);
    });

    setCalculatedValues({
      subtotal,
      totalDiscount,
      totalTax,
      total: subtotal - totalDiscount + totalTax,
    });
  }, [watchedItems, setValue, getValues]);


  const handleItemChange = (index: number, field: string, value: any) => {

    setValue(`items.${index}.${field}` as any, value);

    // Recalculate after state update
    setTimeout(() => {
      calculateInvoiceTotals();
    }, 0);
  };

  const handleItemSelect = (index: number, itemId: string) => {
    const selectedItem = items.find((item: any) => item.ItemId === itemId);

    if (!selectedItem) return;

    // Set ItemId
    setValue(`items.${index}.ItemId`, selectedItem.ItemId);

    // Auto fill price
    setValue(`items.${index}.Price`, selectedItem.SellingPrice || 0);

    // Optional: set default quantity
    const currentQty = getValues(`items.${index}.Quantity`);
    if (!currentQty) {
      setValue(`items.${index}.Quantity`, 1);
    }
  };

  const loadData = async () => {
    try {
      setLoading(true);
      const response = await callAPI(`quotation/${id}`, Method.GET);
      console.log("edit res", response)
      const data = Array.isArray(response.data || response) ? response.data[0] || response[0] : response.data || response;

      reset({
        CustomerId: data.CustomerId || "",
        Remarks: data.Remarks || "",
        items: data.items?.map((item: any) => ({
          ItemId: item.ItemId || "",
          Quantity: item.Quantity || 1,
          Price: item.Price || "",
        })) || [{
          ItemId: "", Quantity: 1, Price: ""
        }],
      });

    } catch (error) {
      console.error("Failed to load purchase:", error);
      showMessage("Failed to load purchase data", "error");
    } finally {
      setLoading(false);
    }
  };
  const fetchAllData = async (url: string) => {
    let allData: any[] = [];
    let page = 1;
    let totalPages = 1;

    try {
      do {
        const response = await callAPI(
          `${url}?page=${page}&pageSize=10`, // keep backend limit
          Method.GET
        );

        const data = response?.data;

        if (data?.results) {
          allData = [...allData, ...data.results];
          totalPages = data.totalPages;
        }

        page++;
      } while (page <= totalPages);

      return allData;

    } catch (error) {
      console.error("Fetch all data error:", error);
      return [];
    }
  };


  useEffect(() => {
    const loadItems = async () => {
      try {
        setLoading(true);

        const response = await callAPI("items/list", Method.GET);

        setItems(Array.isArray(response.data.results) ? response.data.results : []);

        if (isEditMode && id) {
          await loadData();
        }
      } catch (error) {
        console.error("Failed to load data:", error);
        showMessage("Failed to load required data", "error");
      } finally {
        setLoading(false);
      }
    };
    loadItems();
  }, [showMessage, isEditMode, id]);

  useEffect(() => {
    const loadCustomers = async () => {
  try {
    setLoading(true);

    const allCustomers = await fetchAllData("customers/list");

    console.log("All customers:", allCustomers.length); // should be 438

    setCustomers(allCustomers);

  } catch (error) {
    showMessage("Failed to load customers", "error");
  } finally {
    setLoading(false);
  }
};
    loadCustomers();
  }, [showMessage, isEditMode, id]);

  const onSubmit = async (data: any) => {
    try {
      const payload = {
        CustomerId: data.CustomerId || "",
        Remarks: data.Remarks || "",
        items: (data.items || []).map((item: any) => ({
          ItemId: item.ItemId,
          Quantity: Number(item.Quantity) || 0,
          Price: Number(item.Price) || 0,
        })),
      };

      console.log("Final Payload:", payload);
      let response;

      // API call
      if (isEditMode) {
        response = await callAPI(`quotation/update/${id}`, Method.PUT, payload);
      } else {
        response = await callAPI(
          "quotation/create",
          Method.POST,
          payload
        );
      }

      if (response?.success) {
        showMessage(response.message || "Quotation created successfully", "success");
        navigate("/quotation/list");
      } else {
        showMessage(response?.message || "Failed to create quotation", "error");
      }

    } catch (error: any) {
      console.error("Submit Error:", error);
      showMessage(
        error?.response?.data?.message || "Something went wrong",
        "error"
      );
    }
  };

  return (
    <Box sx={{ p: 2, background: "#f0f0f0", minHeight: "100vh" }}>

      {/* HEADER */}
      <Box display="flex" justifyContent="space-between" mb={4}>
        <Typography sx={{ fontSize: "20px", fontWeight: 600 }}>
          Quotation Management
        </Typography>
      </Box>

      {/* QUOTATION DETAILS */}
      <Paper
        sx={{
          borderRadius: "16px",
          p: 3,
          background: "#fafafa",
          mb: 3,
        }}
      >
        <Box display="flex" justifyContent="space-between" mb={6}>
          <Typography sx={{ fontSize: "18px", fontWeight: 500 }}>
            Quotation Details
          </Typography>

          <IconButton
            sx={{ background: "#000", color: "#fff" }}
            onClick={handleSubmit(onSubmit)}
          >
            <SaveIcon fontSize="small" />
          </IconButton>
        </Box>

        <Grid container rowSpacing={8} columnSpacing={5}>

          <Grid item xs={4}>
            <WSSelectField
              name="CustomerId"
              label="Customer"
              id="customer"
              inlineSearch
              control={control}
              options={customers.map(customer => ({
                value: customer.CustomerId,
                label: customer.CustomerName,
              }))}
            />
          </Grid>

          <Grid item xs="auto" display="flex" alignItems="flex-start" sx={{ pl: '12px !important' }}>
            <Box
              onClick={() =>
                navigate("/quotation/customer", { state: { from: "quotation" } })
              }
              sx={{
                height: "36px",
                width: "36px",
                borderRadius: "10px",
                background: "#f3f3f3",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
                flexShrink: 0,
                border: "1px solid #d1d5db",
                "&:hover": {
                  background: "#e0e0e0",
                },
              }}
            >
              <AddIcon fontSize="small" />
            </Box>
          </Grid>

          <Grid item xs={4}>
            <WSTextField
              name="Remarks"
              label="Remarks"
              id="remarks"
              control={control}
            />
          </Grid>

        </Grid>
      </Paper>

      {/* ITEM DETAILS */}
      <Paper sx={{ borderRadius: "16px", p: 3, background: "#fafafa" }}>
        <Box display="flex" justifyContent="space-between" mb={6}>
          <Typography sx={{ fontSize: "18px", fontWeight: 500 }}>
            Item Details
          </Typography>
          <IconButton
            sx={{ background: "#000", color: "#fff" }}
            onClick={() =>
              append({
                ItemId: "",
                Quantity: 1,
                Price: "",
                Total: 0,
              })
            }
          >
            <AddIcon fontSize="small" />
          </IconButton>
        </Box>

        {fields.map((field, index) => (
          <Grid
            container
            rowSpacing={3}
            columnSpacing={3}
            key={field.id}
            alignItems="center"
          >
            {/* Item Number Badge - Mobile/Tablet */}
            <Grid item xs={12} sx={{ display: { xs: "block", md: "none" }, mb: 2 }}>
              <Box
                sx={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: 1,
                  px: 2,
                  py: 0.5,
                  bgcolor: "#f3f4f6",
                  borderRadius: "20px",
                  width: "fit-content",
                }}
              >
                <Typography variant="caption" fontWeight={600} color="#6b7280">
                  Item #{index + 1}
                </Typography>
              </Box>
            </Grid>

            {/* Item Name */}
            <Grid item xs={12} md={3}>
              <WSSelectField
                name={`items.${index}.ItemId`}
                label="Item Name"
                id={`itemName-${index}`}
                control={control}
                inlineSearch
                options={items.map(itemData => ({
                  value: itemData.ItemId,
                  label: `${itemData.ItemCode} - ${itemData.ItemName}`,
                }))}
                onChange={(e: any) => handleItemSelect(index, e.target.value)}
              />
            </Grid>
            <Grid item xs="auto" display="flex" alignItems="flex-start" sx={{ pl: '12px !important' }}>
              <Box
                onClick={() =>
                  navigate("/quotation/itemmaster", { state: { from: "quotation" } })
                }
                sx={{
                  height: "30px",
                  width: "36px",
                  borderRadius: "10px",
                  background: "#f3f3f3",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                  flexShrink: 0,
                  border: "1px solid #d1d5db",
                  "&:hover": {
                    background: "#e0e0e0",
                  },
                }}
              >
                <AddIcon fontSize="small" />
              </Box>
            </Grid>

            {/* Quantity */}
            <Grid item xs={12} md={2}>
              <WSTextField
                {...register(`items.${index}.Quantity`, {
                  onChange: (event) => handleItemChange(index, 'quantity', event.target.value)
                })}
                label="Quantity"
                id={`quantity-${index}`}
                control={control}
                type={TextType.AllowOnlyNumber}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "12px",
                    backgroundColor: "#fafbfc",
                  },
                  "& input": {
                    fontWeight: 500,
                  },
                }}

              />
            </Grid>

            {/* Price */}
            <Grid item xs={12} md={2}>
              <WSTextField
                {...register(`items.${index}.Price`, {
                  onChange: (event) => handleItemChange(index, 'price', event.target.value)
                })}
                label="Price"
                id={`price-${index}`}
                control={control}
                type={TextType.Currency}
                currency={CurrencyType.Rupee}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "12px",
                    backgroundColor: "#fafbfc",
                  },
                  "& input": {
                    fontWeight: 500,
                  },
                }}
              />
            </Grid>

            {/* Total Amount */}
            <Grid item xs={12} md={3}>
              <Paper
                elevation={0}
                sx={{
                  p: 2,
                  background: "linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%)",
                  borderRadius: "12px",
                  height: "56px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  border: "1px solid #bbf7d0",
                  transition: "all 0.2s ease",
                }}
              >
                <Typography variant="body2" fontWeight={500} color="#166534">
                  Total
                </Typography>
                <Typography
                  variant="h6"
                  fontWeight="bold"
                  sx={{
                    background: "linear-gradient(135deg, #166534 0%, #15803d 100%)",
                    backgroundClip: "text",
                    WebkitBackgroundClip: "text",
                    color: "transparent",
                  }}
                >
                  {formatCurrency(Number(watch(`items.${index}.Total`)) || 0)}
                </Typography>
              </Paper>
            </Grid>

            {/* Delete Button */}
            <Grid item xs={12} md={1}>
              <IconButton
                sx={{
                  background: "#fef2f2",
                  color: "#ef4444",
                  width: "40px",
                  height: "40px",
                  transition: "all 0.2s ease",
                  "&:hover": {
                    background: "#fee2e2",
                    transform: "scale(1.05)",
                    "& .MuiSvgIcon-root": {
                      transform: "scale(0.95)",
                    },
                  },
                  "&:disabled": {
                    background: "#f3f4f6",
                    color: "#d1d5db",
                  },
                }}
                onClick={() => remove(index)}
                disabled={fields.length === 1}
              >
                <DeleteIcon fontSize="small" />
              </IconButton>
            </Grid>

            {/* Divider for better separation on mobile */}
            {index < fields.length - 1 && (
              <Grid item xs={12}>
                <Divider
                  sx={{
                    mt: 2,
                    display: { xs: "block", md: "none" },
                    borderColor: "#e5e7eb",
                  }}
                />
              </Grid>
            )}
          </Grid>
        ))}
      </Paper>
    </Box>
  );
};

export default Quotation;